<div id="voucherBase">
    <app-header [headerTitle]="'home.vouchers.0' | translate" [navBack]="'true'" [accessActions]="false"></app-header>

    <div *ngIf="!Voucher" class="contentLoader my-5 py-5"><span></span></div>

    <div *ngIf="Voucher?.name" class="voucherSlide baseContainer">
        <img [src]="Voucher.slider_image_url" [alt]="Voucher.name">
    </div>

    <div *ngIf="Voucher?.name" class="sep white darkWhite">
        <div class="baseContainer">
            <h4>
                <span class="midSize">
                    <!-- <b *ngFor="let provider of Voucher.content_provider_ref; let ind = index"><b *ngIf="!!ind">, </b>{{ provider.name }}</b> -->
                </span>
                <h1>{{ Voucher.name }}</h1>
            </h4>

            <span (click)="gotoInfo()" class="fwIcon"><i class="fas fa-info-circle"></i></span>
            <span *ngIf="!!User$.id" (click)="alreadyLiked ? doDislike() : makeFavourite()" class="fwIcon favorIcon" [class.invert]="!alreadyLiked"><i class="fas fa-heart"></i><i class="far fa-heart"></i></span>
        </div>
    </div>
    
    <div *ngIf="!Offers || !Stock" class="contentLoader my-5 py-5"><span></span></div>

    <div *ngIf="!!Offers?.length && !!Stock" class="baseContainer">

        <section class="inquerit" [class.disabled]="loading_">
            <h6>{{ 'home.chooseVoucher' | translate }}</h6>
            
            <button *ngFor="let voucher of Offers" class="paymentMethod" (click)="selectedVoucher = voucher" [class.select]="selectedVoucher == voucher"
                [disabled]="!Stock[voucher.id] || Stock[voucher.id] <= 0 || (!!voucher.upar_offer_tag_reference?.length && voucher.upar_offer_tag_reference[0].name == 'SOLD_OUT')">
                <p [innerHTML]="voucher.game_coin_value + ' ' + voucher.game_coin_label"
                    class="{{ Stock[voucher.id] <= 0 ? 'promo' : !!voucher.upar_offer_tag_reference?.length ? 'promo ' + voucher.upar_offer_tag_reference[0].name : '' }}"
                    [title]="( Stock[voucher.id] <= 0 ? 'global.tag.SOLD_OUT' : !!voucher.upar_offer_tag_reference?.length ? 'global.tag.'+ voucher.upar_offer_tag_reference[0].name : '') | translate"></p>
                <span class="userCoins" [innerHTML]="(voucher.ups_value | number:'1.0-0':'fr') +' <sup>'+ (global.propConfs$.coinSymbol || 'UP$') +'</sup>'"></span>
            </button>
        </section>

        <div class="buyVoucher">
            <div class="balance">
                <h6>{{ 'home.myBalance' | translate }}</h6>
                <span class="userCoins" [innerHTML]="(!!User$.id ? (UserCredits$ | number:'1.0-0':'fr') : 0) +' <sup>'+ (global.propConfs$.coinSymbol || 'UP$') +'</sup>'"></span>
            </div>
            <button class="btn" [class.notLoading]="!loading_" (click)="doBuyVoucher()" [disabled]="!selectedVoucher || loading_">{{ 'home.buy' | translate }}</button>
        </div>

    </div>

    <div id="voucherInfo" *ngIf="Voucher?.name && (!!Voucher.android_app_url || !!Voucher.ios_app_url || !!Voucher.web_app_url || !!Voucher.description || !!Voucher.how_to_redeem)" class="topUpInfo">
        <div class="baseContainer">
            <span class="infoIc"><i class="fas fa-info-circle"></i></span>
            <div class="infoTx">
                <div *ngIf="!!Voucher.description" [innerHTML]="Voucher.description"></div>
                <a *ngIf="!!Voucher.android_app_url" [href]="Voucher.android_app_url" class="appStore" target="_blank"><img src="https://webportals.cachefly.net/global/upar/assets/images/Google_Play_Store.png" alt="Google Play Store"></a>
                <a *ngIf="!!Voucher.ios_app_url" [href]="Voucher.ios_app_url" class="appStore" target="_blank"><img src="https://webportals.cachefly.net/global/upar/assets/images/Aple_App_Store.png" alt="Apel App Store"></a>
                <div *ngIf="!!Voucher.web_app_url" class="webLink">
                    <h5>{{ 'home.more' | translate }}</h5>
                    <a [href]="Voucher.web_app_url" target="_blank">{{ Voucher.web_app_url.replace('https://', '').replace('http://', '') }}</a>
                </div>
            </div>
        </div>        
    </div>

    <div *ngIf="!!Voucher?.how_to_redeem" id="howtouse" class="topUpInfo">
        <div class="baseContainer">
            <div class="howRedeem" [innerHTML]="Voucher.how_to_redeem"></div>
        </div>
    </div>

    <div *ngIf="Voucher" class="baseContainer otherGames">
        <h6>{{ 'home.otherGames' | translate: { provider: '' } }}</h6>

        <main class="voucherBox">

            <a *ngFor="let voucher of OutherGames" routerLink="/voucher/{{ voucher.id }}" [hidden]="voucher.type == 'SLIDER'" class="voucher">
                <img [src]="voucher.image_url" [alt]="voucher.name">
                <span [class.hided]="!voucher.discountLabel" [innerHTML]="voucher.discountLabel || '-'"></span>
                <b>{{ voucher.name }}</b>
                <p [innerHTML]="voucher.priceLabel"></p>
            </a>

            <h5 *ngIf="OutherGames && !OutherGames.length" class="text-center py-5 my-5">{{ 'home.noVoucherFound' | translate }}</h5>

            <div *ngIf="!OutherGames" class="contentLoader my-5 py-5"><span></span></div>

        </main>
    </div>

</div>